export default __webpack_public_path__ + "img/fee.c819475ea233eab5d9ec6dd6f3214e81.png";